import type { CardRootProps, FlexProps } from '@chakra-ui/react';
import { Card, Flex, Heading } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';
import React from 'react';

export interface FilterPanelProps extends CardRootProps {
  title?: string;
  rounded?: string;
  bodyProps?: React.ComponentProps<typeof Card.Body>;
  actionsSlot?: any;
  contentDirection?: FlexProps['direction'];
}

export const FilterPanel = ({
  children,
  title,
  rounded = 'lg',
  bodyProps,
  actionsSlot,
  contentDirection = { base: 'column', md: 'row' },
  ...props
}: PropsWithChildren<FilterPanelProps>) => {
  return (
    <Card.Root rounded={rounded} shadow="none" borderColor="border" {...props}>
      <Card.Body p={3} {...bodyProps}>
        <Flex
          justify="space-between"
          w="full"
          align="center"
          direction={contentDirection}
          wrap="wrap"
          gap={4}
        >
          <Flex align="center" flex="1" gap={4}>
            {title && (
              <Heading size="lg" color="gray.900">
                {title}
              </Heading>
            )}
            {children}
          </Flex>
          {actionsSlot}
        </Flex>
      </Card.Body>
    </Card.Root>
  );
};
